export default "__VITE_ASSET__mX5rygxP__"